import { Injectable, InjectionToken } from '@angular/core';
import { firstValueFrom, noop } from 'rxjs';
import { placerOrderData } from 'estensa-module';
import { RouterStackService, ServerRootService } from '@se/se.ui.html5';
import { HttpClient } from '@angular/common/http';
import { ReportWorkflowService } from './report-workflow.service';
import { CardiologyVisitRestService } from './cardiology-visit-rest.service';
import { getReportingPageFromExaminations } from '../custom-pages/reporting-check';
import { SearchFormType } from '../search-page/search-page-type.enum';
import { ReportingDataBuilder } from './reporting-data-builder.service';
import { HttpMasterDataResolver } from '../custom-pages/services/http-data-resolver';

export const ESTENSA_MODULE_THIRD_PART_SUPPORT_SERVICE =
    new InjectionToken('estensa.module.third.part.support.service');

@Injectable()
export class NullThirdPartSupportService {
    initService = noop;
    destroy = noop;
    getExaminationById = noop;
    getExaminationIdFromPlacerOrderData = noop;
    goToVisit = noop;
    goToECG = noop;
}

@Injectable({
    providedIn: 'root',
})
export class ThirdPartSupportService extends ServerRootService {
    // constructor

    constructor(
        private reportingDataBuilder: ReportingDataBuilder,
        private httpClient: HttpClient,
        private httpMasterDataResolver: HttpMasterDataResolver,
        private reportWorkflowService: ReportWorkflowService,
        private routerStackService: RouterStackService,
        private visitRestService: CardiologyVisitRestService,
    ) {
        super();
    }

    // public functions

    public getExaminationById = (examinationId: string) => {
        //chiamare metodo marce
        return this.httpClient.post(
            this.getServerRoot() + '/Visit/GetExaminationById',
            '"' + examinationId + '"',
            this.buildOptions(),
        );
    };

    public getExaminationIdFromPlacerOrderData = (placerOrderData: placerOrderData) => {
        //chiamare metodo marce
        return this.httpClient.post(
            this.getServerRoot() + '/Integration/GetExaminationIdFromPlacerOrderData',
            placerOrderData,
            this.buildOptions(),
        );
    };

    async goToReporting(examinationId: string) {
        const visitExamination: any = await firstValueFrom(this.getExaminationById(examinationId));
        const check = getReportingPageFromExaminations([visitExamination]);
        if (check === SearchFormType.VISIT) {
            const params = await this.reportingDataBuilder.prepareCpParams(
                [visitExamination],
                this.httpMasterDataResolver,
                this.visitRestService,
                this.reportWorkflowService,
            );
            this.routerStackService.go('/new/vnext/cardio-visit/report', params);
        } else if (check === SearchFormType.ECG) {
            const params = this.reportingDataBuilder.prepareECGParams([visitExamination]);
            this.routerStackService.go('/new/vnext/ecg/reporting-details', params);
        }
    }
}
